import React from "react";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";

// import isEqual from 'lodash/isEqual';


export class MineViewStudyTime extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			allTime: parseInt(this.props.data),
			m: 0,
			h: 0,
			d: 0,
			showDay: false
		};

	}


	componentWillReceiveProps(nextProps) {
		this.setState({
			m: nextProps.data % 60,
			h: parseInt(nextProps.data / 60 % 24),
			d: parseInt(nextProps.data / 60 / 24),
			showDay: this.state.d > 0
		})

	}

	render() {
		return (
			<GridContainer justify="flex-end">
				{
					this.state.showDay ?

						<div>
							{this.state.d}
							<span style={{}}>
								d
							</span>
						</div>
						:
						null
				}


				{this.state.h}
				<span style={{}}>
					h
				</span>
				{
					this.state.showDay ?
						null
						:
						<div>
							{this.state.m}
							<span style={{}}>
								m
							</span>
						</div>

				}
			</GridContainer>
		)
	}
}